import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, OnInit } from '@angular/core';

@Component({
  selector: 'app-capability-description',
  templateUrl: './capability-description.component.html',
  styleUrls: ['./capability-description.component.scss']
})
export class CapabilityDescriptionComponent implements OnInit {

  previousCapability: string;
  previousDescription: string;
  readOnly: boolean;

  constructor(public dialogRef: MatDialogRef<CapabilityDescriptionComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.previousCapability = this.data.capabilityDetails.capabilities;
    this.previousDescription = this.data.capabilityDetails.description;
    this.readOnly = this.data.readOnly;
  }

  cancelAndClose() {
    this.data.capabilityDetails.capabilities = this.previousCapability;
    this.data.capabilityDetails.description = this.previousDescription;
    this.dialogRef.close();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  capabilityLength() {
    if (this.data && this.data.capabilityDetails.capabilities) {
      return this.data.capabilityDetails.capabilities.length;
    }
    else {
      return 0;
    }
  }

  descriptionLength() {
    if (this.data && this.data.capabilityDetails.description) {
      return this.data.capabilityDetails.description.length;
    }
    else {
      return 0;
    }
  }

}
